/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/**
 * Forked from:
 * https://github.com/dixahq/elevio-chrome-integrations/blob/main/src/background/analytics/snowcat.ts
 *
 * Opted to disable these eslint rules so I can use the original code:
 *
 * - Prefer-rest-params
 * - @typescript-eslint/ban-ts-comment
 */

import { ElevioSuggestionState } from '../elevio.reducer/suggestion';
import { ElevioError } from '../utils';

import {
  snowcatAppId,
  snowcatNamespace,
  snowcatPlatform,
  snowcatUrl,
} from './config';

export function setup(): void {
  if (process.env.NODE_ENV === 'test') return;
  loadSnowcat();
  setOptions();
}

interface CustomWindow extends Window {
  elevio_snowcat(method: string, ...args: unknown[]): void;
}
declare let window: CustomWindow;

export async function trackSelfDescribingEvent(
  schema: string,
  data: Object,
  url: string | undefined,
  languageId: string | undefined,
): Promise<void> {
  if (process.env.NODE_ENV === 'test') return;

  if (!languageId) {
    throw ElevioError({
      context: 'Snowcat',
      feature: 'suggestions',
      message: `No languageId provided for ${JSON.stringify(data)}`,
    });
  }
  const { store } = await import('bootstrap.store');

  const suggestions = store.getState().elevio
    .suggestions as ElevioSuggestionState;
  const { companyUid, userId, userEmail: user_email } = suggestions;

  const app_version = VERSION;

  // Because events can be triggered before useEffect has a chance to run
  // let's make sure it's loaded before we fire events.
  if (!window.elevio_snowcat) {
    setup();
  }

  try {
    window.elevio_snowcat?.('setCustomUrl', url);
    window.elevio_snowcat?.(
      'trackSelfDescribingEvent',
      {
        schema,
        data,
      },
      [
        {
          schema: 'iglu:com.elevio/context/jsonschema/1-0-1',
          data: {
            customer_uid: companyUid,
            user_id: userId?.toString(),
            language_id: languageId,
            user_email,
            app_version,
          },
        },
      ],
    );
  } catch (error) {
    // This is here in case elevio_snowcat hasn't loaded yet.
  }
}

function loadSnowcat() {
  const scriptUrl = `${window.location.origin}/assets/libs/javascript/snowplow.js`;

  (function (p, l, o, w, i, n, g) {
    // @ts-ignore
    if (!p[i]) {
      // @ts-ignore
      p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
      // @ts-ignore
      p.GlobalSnowplowNamespace.push(i);
      // @ts-ignore
      p[i] = function () {
        // @ts-ignore
        (p[i].q = p[i].q || []).push(arguments);
      };
      // @ts-ignore
      p[i].q = p[i].q || [];
      // @ts-ignore
      n = l.createElement(o);
      // @ts-ignore
      g = l.getElementsByTagName(o)[0];
      // @ts-ignore
      n.async = 1;
      // @ts-ignore
      n.src = w;
      // @ts-ignore
      g.parentNode.insertBefore(n, g);
    }
  })(window, document, 'script', scriptUrl, 'elevio_snowcat');
}

function setOptions() {
  window.elevio_snowcat(
    'newTracker',
    snowcatNamespace || 'snowcat',
    snowcatUrl,
    {
      appId: snowcatAppId,
      platform: snowcatPlatform || 'web',
      cookieDomain: null,
      discoverRootDomain: true,
      cookieName: null,
      // encodeBase64: false,
      respectDoNotTrack: false,
      userFingerprint: true,
      userFingerprintSeed: 6385926734,
      // pageUnloadTimer: 0,
      forceSecureTracker: true,
      // eventMethod: 'post',
      // bufferSize: 1,
      maxPostBytes: 50000000, // 50mb
      stateStorageStrategy: 'localStorage',
      connectionTimeout: 10000,
      contexts: {
        webPage: true,
        performanceTiming: false,
        gaCookies: false,
        geolocation: false,
      },
    },
  );
  // @ts-ignore
  window.elevio_snowcat('setDebug', true);
}

export function setupUnload(): void {
  window.elevio_snowcat?.('flushBuffer');
}
